<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="stockTemplate.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="description"
                  label="Description"
                  v-model="stockTemplate.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-textarea>
              </v-flex>
              <v-flex sm6>
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12 v-if="stockTemplate.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTemplate.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockTemplate.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockTemplate.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTemplate.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockTemplate.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addStockTemplateItem()">
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs4>Product</v-flex>
                  <v-flex xs1>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(stockTemplateItem, index) in stockTemplate.stockTemplateItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      placeholder="Select the code"
                      v-model="stockTemplateItem.productCode"
                      @click="showProducts(), selectedTemplatedex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="stockTemplateItem.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-autocomplete
                      v-model="stockTemplateItem.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="stockTemplateItem.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      label="Select"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="stockTemplateItem.qty"
                      min="0"
                      :rules="rules.qtyRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeStockTemplateItem(index, stockTemplateItem.id)"
                      :disabled="index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="stockTemplate.id?true:false">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code, selectedTemplatedex), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { productService } from "../../services/product-service";
import { stockTemplateService } from "../../services/stock-template-service";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { StockTemplateItem } from "../../models/model";
import { StockTemplate } from "../../models/model";
import { StockTemplateFormRules } from "../../helpers/validation-rules";

export default {
  name: "StockTemplateDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Stock Template",
        disabled: false,
        to: "stock-templatess",
      },
      {
        text: "Stock Template Detail",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    issueDate: "",
    stockTemplate: new StockTemplate(),
    oldStockTemplate: new StockTemplate(),
    stockTemplateItem: new StockTemplateItem(),
    rules: new StockTemplateFormRules(),
    responseError: "",
    messageDialogBox: false,
    showAutocompleteLoading: false,
    saveLoading: false,
    productUnitList: [],
    productList: [],
    btnDisabled: false,
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0,
    statusFlag: true,
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      this.addStockTemplateItem();
    } else {
      this.getStockTemplateDetail(id);
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    goBack() {
      this.$router.push("/stock-templates");
    },
    addStockTemplateItem() {
      // deep copy
      stockTemplateItem = new StockTemplateItem();
      let stockTemplateItem = JSON.parse(
        JSON.stringify(this.stockTemplateItem)
      );

      this.stockTemplate.stockTemplateItems.push(stockTemplateItem);
    },

    removeStockTemplateItem(index, stockTemplateItemId) {
      if (stockTemplateItemId) {
        // add delete stock in id
        if (!this.stockTemplate.deleteStockTemplateItemIds) {
          this.stockTemplate.deleteStockTemplateItemIds = [];
        }
        this.stockTemplate.deleteStockTemplateItemIds.push(stockTemplateItemId);
      }
      this.$delete(this.stockTemplate.stockTemplateItems, index);
    },

    getStockTemplateDetail(id) {
      stockTemplateService
        .getStockTemplateDetail(id)
        .then((res) => {
          this.stockTemplate = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockTemplate.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockTemplate.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.status = this.stockTemplate.status;
          // deep copy
          this.oldStockTemplate = JSON.parse(JSON.stringify(res.data));

          this.statusFlag =
            this.stockTemplate.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.stockTemplate.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        stockTemplateService
          .saveStockTemplate(this.stockTemplate)
          .then((res) => {
            if (res) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockTemplate.id) {
        this.stockTemplate = new StockTemplate();
        this.addStockTemplateItem();
        this.statusFlag = true;
      } else {
        this.stockTemplate = JSON.parse(JSON.stringify(this.oldStockTemplate));
        this.statusFlag = this.stockTemplate.status == "ACTIVE" ? true : false;
      }
    },

    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockTemplate.stockTemplateItems[index].productCode = product.code;
      this.stockTemplate.stockTemplateItems[index].productName = product.name;
      // set default unit
      var j = "";
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.stockTemplate.stockTemplateItems[index].factorUnitName =
        product.productUnits[j].factorUnitName;
      this.stockTemplate.stockTemplateItems[index].productUnits =
        product.productUnits;
      this.stockTemplate.stockTemplateItems[index].unitCost = 0;
      this.stockTemplate.stockTemplateItems[index].sellingPrice = 0;
      this.stockTemplate.stockTemplateItems[index].qty = 0;
    },
    prepareStockTemplateItems(item) {
      var stockTemplate = this.stockTemplate;
      stockTemplate.poNo = item.issueNo;
      // Clear previous datas
      stockTemplate.stockTemplateItems = [];

      let purchaseOrderItems = item.purchaseOrderItems;
      if (purchaseOrderItems) {
        purchaseOrderItems.forEach((item) => {
          let stockTemplateItem = {
            productCode: "",
            productName: "",
            factorUnitName: "",
            productUnits: "",
            unitCost: 0,
            sellingPrice: 0,
            qty: 0,
            remark: "",
          };
          stockTemplateItem.productCode = item.productCode;
          stockTemplateItem.productName = item.productName;
          stockTemplateItem.factorUnitName = item.factorUnitName;
          stockTemplateItem.productUnits = item.productUnits;
          stockTemplateItem.unitCost = item.unitCost;
          stockTemplateItem.sellingPrice = item.sellingPrice;
          stockTemplateItem.qty = item.qty;
          stockTemplateItem.remark = item.remark;
          stockTemplate.stockTemplateItems.push(stockTemplateItem);
        });
      }
    },
  },
};
</script>

